<template>
    <div v-if="dialogFormVisible" class="rule">
        <el-dialog v-el-drag-dialog :title="'编辑任务交办'" :visible.sync="dialogFormVisible" :append-to-body="true" width="1300px" :close-on-click-modal="false" destroy-on-close>
            <el-form ref="ruleForm" :rules="rules" :model="form" style="text-align: center">
                <div class="el-table el-table--fit el-table--border">
                    <div class="el-table__body-wrapper">
                        <table cellspacing="0" cellpadding="0" border="0" class="el-table__body">
                            <tbody>
                                <!-- 任务信息字段 -->
                                <tr v-if="!vo.isPl">
                                    <td ref="tdlbl_督办类型 " class="el-table__cell tdlbl tdw17" colspan="1">
                                        <span class="required">*</span>
                                        <span v-field-lbl="'dbType'" class="field">督办类型</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw33" colspan="2">
                                        <form-item
                                            ref="dbType"
                                            :field="{
                                                defaultValue: null,
                                                elementCanEdit: '{{curTN.tnCanEdit}}',
                                                elementCssHeight: null,
                                                elementCssWidth: null,
                                                elementFormatter: '0：会议决定\n1：领导批示\n2：领导交办\n3：重要文件\n4：事项项目',
                                                elementReadonly: null,
                                                elementType: 'select',
                                                emptyMessage: '请选择督办类型 ',
                                                errorMessage: null,
                                                formTdAlign: 'text-left',
                                                formTdColspan: 0,
                                                isRequired: 1,
                                                onClickEvent: null,
                                                passenger: {},
                                                propComment: '督办类型 ',
                                                propName: 'dbType',
                                                propType: 'Short',
                                                textFormatter: null,
                                                valueMaxLength: null,
                                                valueMinLength: null,
                                                model: 'vo.dbType',
                                                option: dbTypeOptions,
                                                optionGenerateType: 0,
                                                clearable: true,
                                                filterable: false,
                                                allowCreate: false
                                            }"
                                            :vo="vo"
                                            :can-edit="1"
                                        />
                                    </td>
                                    <td ref="tdlbl_督办模式 " class="el-table__cell tdlbl tdw17" colspan="1">
                                        <span class="required">*</span>
                                        <span v-field-lbl="'dbMode'" class="field">督办模式</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw33" colspan="2">
                                        <form-item
                                            ref="dbMode"
                                            :field="{
                                                defaultValue: null,
                                                elementCanEdit: '{{curTN.tnCanEdit}}',
                                                elementCssHeight: null,
                                                elementCssWidth: null,
                                                elementFormatter: '0：周督办\n1：月度督办\n2：季度督办\n3：一次督办\n4：自定义',
                                                elementReadonly: null,
                                                elementType: 'select',
                                                emptyMessage: '请选择督办模式 ',
                                                errorMessage: null,
                                                formTdAlign: 'text-left',
                                                formTdColspan: 0,
                                                isRequired: 1,
                                                onClickEvent: null,
                                                passenger: {},
                                                propComment: '督办模式 ',
                                                propName: 'dbMode',
                                                propType: 'Short',
                                                textFormatter: null,
                                                valueMaxLength: null,
                                                valueMinLength: null,
                                                model: 'vo.dbMode',
                                                option: [
                                                    { value: '0', name: '周督办' },
                                                    { value: '1', name: '月度督办' },
                                                    { value: '2', name: '季度督办' },
                                                    { value: '3', name: '一次督办' },
                                                    { value: '4', name: '自定义' }
                                                ]
                                            }"
                                            :vo="vo"
                                            :can-edit="1"
                                        />
                                    </td>
                                </tr>
                                <tr>
                                    <td ref="tdlbl_重要程度" class="el-table__cell tdlbl tdw17" colspan="1">
                                        <span class="required">*</span>
                                        <span v-field-lbl="'importantLevel'" class="field">重要程度</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw33" colspan="2">
                                            <form-item ref="importantLevel" :field="{'defaultValue':null,'elementCanEdit':'{${curTN.tnCanEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':'0：普通\n1：重要\n2：非常重要','elementReadonly':1,'elementType':'select','emptyMessage':'请选择重要程度','errorMessage':null,'formTdAlign':'text-left','formTdColspan':12,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'重要程度','propName':'importantLevel','propType':'Short','textFormatter':null,'valueMaxLength':null,'valueMinLength':null,'model':'vo.importantLevel','option':[{'value':'0','name':'普通'},{'value':'1','name':'重要'},{'value':'2','name':'非常重要'}]}" :vo="vo" :can-edit="canEdit" />
                                    </td>
                                    <td ref="tdlbl_紧急程度" class="el-table__cell tdlbl tdw17" colspan="1">
                                        <span class="required">*</span>
                                        <span v-field-lbl="'urgentLevel'" class="field">紧急程度</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw33" colspan="2">
                                            <form-item ref="urgentLevel" :field="{'defaultValue':null,'elementCanEdit':'{${curTN.tnCanEdit}}','elementCssHeight':null,'elementCssWidth':null,'elementFormatter':'0：平件\n1：紧急\n2：特急','elementReadonly':1,'elementType':'select','emptyMessage':'请选择紧急程度','errorMessage':null,'formTdAlign':'text-left','formTdColspan':12,'isRequired':1,'onClickEvent':null,'passenger':{},'propComment':'紧急程度','propName':'urgentLevel','propType':'Short','textFormatter':null,'valueMaxLength':null,'valueMinLength':null,'model':'vo.urgentLevel','option':[{'value':'0','name':'平件'},{'value':'1','name':'紧急'},{'value':'2','name':'特急'}]}" :vo="vo" :can-edit="canEdit" />
                                    </td>
                                </tr>
                                <tr>
                                    <td ref="tdlbl_督办人" class="el-table__cell tdlbl tdw17" colspan="1">
                                        <span class="required">*</span>
                                        <span v-field-lbl="'dbMater'" class="field">督办人</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw33" colspan="2">
                                        <form-item
                                            ref="dbMater"
                                            :field="{
                                                defaultValue: null,
                                                elementCanEdit: '1',
                                                elementCssHeight: 70,
                                                elementCssWidth: null,
                                                elementFormatter: null,
                                                elementReadonly: 1,
                                                elementType: 'textarea',
                                                emptyMessage: '请选择督办人',
                                                errorMessage: null,
                                                formTdAlign: 'text-left',
                                                formTdColspan: 24,
                                                isRequired: 0,
                                                onClickEvent: null,
                                                passenger: {},
                                                propComment: '督办人',
                                                propName: 'dbMater',
                                                propType: 'String',
                                                textFormatter: 'textarea',
                                                valueMaxLength: 2147483647,
                                                valueMinLength: null,
                                                model: 'vo.dbMater',
                                                option: [],
                                                dialog: 1,
                                                dialogType: 'staff',
                                                dialogMultiple: false,
                                                dialogOrgLevel: '',
                                                autosize: false,
                                                dialogSubOrgName: '',
                                                valueIdsField: 'readersAccountId'
                                            }"
                                            :vo="vo"
                                            :can-edit="1"
                                            :autosize="false"
                                        />
                                        <!-- <div>{{ vo.dbMater }}</div> -->
                                    </td>
                                    <td ref="tdlbl_督办部门 " class="el-table__cell tdlbl tdw17" colspan="1">
                                        <span class="required">*</span>
                                        <span v-field-lbl="'dbMaterDept'" class="field">督办部门</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw33" colspan="2">
                                        <form-item
                                            ref="dbMaterDept"
                                            :field="{
                                                defaultValue: null,
                                                elementCanEdit: '1',
                                                elementCssHeight: 70,
                                                elementCssWidth: null,
                                                elementFormatter: null,
                                                elementReadonly: 1,
                                                elementType: 'textarea',
                                                emptyMessage: '请选择督办部门',
                                                errorMessage: null,
                                                formTdAlign: 'text-left',
                                                formTdColspan: 24,
                                                isRequired: 0,
                                                onClickEvent: null,
                                                passenger: {},
                                                propComment: '督办部门',
                                                propName: 'dbMaterDept',
                                                propType: 'String',
                                                textFormatter: 'textarea',
                                                valueMaxLength: 2147483647,
                                                valueMinLength: null,
                                                model: 'vo.dbMaterDept',
                                                option: [],
                                                dialog: 1,
                                                dialogType: 'suborg',
                                                dialogMultiple: true,
                                                dialogOrgLevel: '',
                                                autosize: false,
                                                dialogSubOrgName: '',
                                                valueIdsField: 'readersAccountId'
                                            }"
                                            :vo="vo"
                                            :can-edit="canEdit"
                                            :autosize="false"
                                        />
                                        <!-- <div>{{ vo.dbMaterDept }}</div> -->
                                    </td>
                                </tr>
                                <tr>
                                    <td ref="tdlbl_任务编号 " class="el-table__cell tdlbl tdw17" colspan="1">
                                        <span class="required">*</span>
                                        <span v-field-lbl="'taskCode'" class="field">任务编号</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw83" colspan="5">
                                        <form-item ref="taskCode" :field="{ defaultValue: null, elementCanEdit: '1', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入任务标题', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 1, onClickEvent: null, passenger: {}, propComment: '任务标题', propName: 'taskCode', propType: 'String', textFormatter: 'textfield', valueMaxLength: null, valueMinLength: null, model: 'vo.taskCode', option: [] }" :vo="vo.passenger.task" :can-edit="1" />
                                        <!-- <div>{{ vo.taskCode }}</div> -->
                                    </td>
                                </tr>
                                <tr>
                                    <td ref="tdlbl_任务标题 " class="el-table__cell tdlbl tdw17" colspan="1">
                                        <span class="required">*</span>
                                        <span v-field-lbl="'title'" class="field">任务标题</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw83" colspan="5">
                                        <form-item ref="title" :field="{ defaultValue: null, elementCanEdit: '1', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'input', emptyMessage: '请输入任务标题', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 1, onClickEvent: null, passenger: {}, propComment: '任务标题', propName: 'title', propType: 'String', textFormatter: 'textfield', valueMaxLength: null, valueMinLength: null, model: 'vo.title', option: [] }" :vo="vo.passenger.task" :can-edit="1" />
                                        <!-- <div>{{ vo.title }}</div> -->
                                    </td>
                                </tr>
                                <tr>
                                    <td ref="tdlbl_任务内容 " class="el-table__cell tdlbl tdw17" colspan="1">
                                        <span class="required">*</span>
                                        <span v-field-lbl="'content'" class="field">任务内容</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw83" colspan="5">
                                        <form-item ref="content" :field="{ defaultValue: null, elementCanEdit: '1', elementCssHeight: null, elementCssWidth: null, elementFormatter: null, elementReadonly: 0, elementType: 'textarea', emptyMessage: '请输入任务内容', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 1, onClickEvent: null, passenger: {}, propComment: '任务内容', propName: 'content', propType: 'String', textFormatter: 'textfield', valueMaxLength: null, valueMinLength: null, model: 'vo.content', option: [] }" :vo="vo.passenger.task" :can-edit="1" />
                                        <!-- <div>{{ vo.content }}</div> -->
                                    </td>
                                </tr>
                                <tr>
                                    <td ref="tdlbl_承办部门" class="el-table__cell tdlbl tdw17" colspan="1">
                                        <span class="required">*</span>
                                        <span v-field-lbl="'qtDept'" class="field">承办部门</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw33" colspan="2">
                                        <form-item
                                            ref="qtDept"
                                            :field="{
                                                defaultValue: null,
                                                elementCanEdit: '1',
                                                elementCssHeight: 70,
                                                elementCssWidth: null,
                                                elementFormatter: null,
                                                elementReadonly: 1,
                                                elementType: 'textarea',
                                                emptyMessage: '请选择承办部门',
                                                errorMessage: null,
                                                formTdAlign: 'text-left',
                                                formTdColspan: 24,
                                                isRequired: 0,
                                                onClickEvent: null,
                                                passenger: {},
                                                propComment: '承办部门',
                                                propName: 'qtDept',
                                                propType: 'String',
                                                textFormatter: 'textarea',
                                                valueMaxLength: 2147483647,
                                                valueMinLength: null,
                                                model: 'vo.qtDept',
                                                option: [],
                                                dialog: 1,
                                                dialogType: 'suborg',
                                                dialogMultiple: true,
                                                dialogOrgLevel: '2',
                                                autosize: false,
                                                dialogSubOrgName: '',
                                                valueIdsField: 'readersAccountId'
                                            }"
                                            :vo="vo.passenger.task"
                                            :can-edit="1"
                                            :autosize="false"
                                        />
                                        <div>{{ vo.qtDept }}</div>
                                    </td>
                                    <td ref="tdlbl_会办部门 " class="el-table__cell tdlbl tdw17" colspan="1">
                                        <span v-field-lbl="'phDept'" class="field">会办部门</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw33" colspan="2">
                                        <form-item
                                            ref="phDept"
                                            :field="{
                                                defaultValue: null,
                                                elementCanEdit: '1',
                                                elementCssHeight: 70,
                                                elementCssWidth: null,
                                                elementFormatter: null,
                                                elementReadonly: 1,
                                                elementType: 'textarea',
                                                emptyMessage: '请选择会办部门',
                                                errorMessage: null,
                                                formTdAlign: 'text-left',
                                                formTdColspan: 24,
                                                isRequired: 0,
                                                onClickEvent: null,
                                                passenger: {},
                                                propComment: '会办部门',
                                                propName: 'phDept',
                                                propType: 'String',
                                                textFormatter: 'textarea',
                                                valueMaxLength: 2147483647,
                                                valueMinLength: null,
                                                model: 'vo.phDept',
                                                option: [],
                                                dialog: 1,
                                                dialogType: 'suborg',
                                                dialogMultiple: true,
                                                dialogOrgLevel: '2',
                                                autosize: false,
                                                dialogSubOrgName: '',
                                                valueIdsField: 'readersAccountId'
                                            }"
                                            :vo="vo.passenger.task"
                                            :can-edit="1"
                                            :autosize="false"
                                        />
                                        <!-- <div>{{ vo.phDept }}</div> -->
                                    </td>
                                </tr>
                                <tr>
                                    <td ref="tdlbl_开始时间" class="el-table__cell tdlbl tdw17" colspan="1">
                                        <span class="required">*</span>
                                        <span v-field-lbl="'startDate'" class="field">开始时间</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw33" colspan="2">
                                        <form-item
                                            ref="startDate"
                                            :field="{ defaultValue: null, elementCanEdit: '1', elementCssHeight: null, elementCssWidth: null, elementFormatter: 'format：yyyy-MM-dd HH:mm\r\n', elementReadonly: 1, elementType: 'date', emptyMessage: '请输入开始时间 ', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 1, onClickEvent: null, passenger: {}, propComment: '开始时间 ', propName: 'startDate', propType: 'java.util.Date', textFormatter: 'yyyy-MM-dd HH:mm\r\n', valueMaxLength: null, valueMinLength: null, model: 'vo.startDate', option: [] }"
                                            :vo="vo.passenger.task"
                                            :can-edit="1"
                                        />
                                        <!-- <div>{{ $moment(vo.startDate).format('YYYY-MM-DD HH:mm') }}</div> -->
                                    </td>
                                    <td ref="tdlbl完成时限 " class="el-table__cell tdlbl tdw17" colspan="1">
                                        <span class="required">*</span>
                                        <span v-field-lbl="'overDate'" class="field">完成时限</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw33" colspan="2">
                                        <form-item
                                            ref="overDate"
                                            :field="{ defaultValue: null, elementCanEdit: '1', elementCssHeight: null, elementCssWidth: null, elementFormatter: 'format：yyyy-MM-dd HH:mm\r\n', elementReadonly: 1, elementType: 'date', emptyMessage: '请输入完成时限 ', errorMessage: null, formTdAlign: 'text-left', formTdColspan: 0, isRequired: 1, onClickEvent: null, passenger: {}, propComment: '完成时限 ', propName: 'overDate', propType: 'java.util.Date', textFormatter: 'yyyy-MM-dd HH:mm\r\n', valueMaxLength: null, valueMinLength: null, model: 'vo.overDate', option: [] }"
                                            :vo="vo.passenger.task"
                                            :can-edit="1"
                                        />
                                        <!-- <div>{{ $moment(vo.overDate).format('YYYY-MM-DD HH:mm') }}</div> -->
                                    </td>
                                </tr>
                                <tr>
                                    <td ref="tdlbl_附件 " class="el-table__cell tdlbl tdw17" colspan="1">
                                        <span v-field-lbl="'isTop'" class="field">附件</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw83" colspan="5">
                                        <FileList ref="attachments" wf-attach-url="dcdb/task" :can-edit="'0'" :vo="vo" :is-required="0" accept="*.*" empty-message="" :limit-count="10" online-editor="" online-file="" :attachments="vo.passenger.attachments" :attachs-type="'ATTACH'" />
                                        <!-- <GwFileList ref="attachments" wf-attach-url="dcdb/task" :can-edit="canEdit" :vo="vo" :is-required="0" accept="*.*" empty-message="" :limit-count="10" online-editor="" online-file="" :attachments="vo.passenger.attachments" :attachs-type="'ATTACH'" /> -->
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="6" style="text-align: left">监管规则</td>
                                </tr>

                                <!-- 监管规则 -->
                                <tr>
                                    <td class="el-table__cell tdlbl tdw17" colspan="1">
                                        <span class="required" style="color: red">*</span>
                                        <span v-text-lbl="'jbTime'">督办模式</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw83" colspan="5">
                                        <template>
                                            <template v-if="canEdit">
                                                <div v-if="vo.status === 0 || vo.taskStatus === 1 || vo.taskStatus === 9">
                                                    <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="督办模式" rules="required">
                                                        <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                                            <el-select v-model="crow.dbMode" size="small" class="w120" placeholder="请选择" @change="changeValue">
                                                                <el-option v-for="item in moduleType" :key="item.value" :label="item.label" :value="item.value" />
                                                            </el-select>
                                                        </el-tooltip>
                                                    </ValidationProvider>
                                                </div>
                                                <div v-else>
                                                    {{ crow.dbMode !== null ? moduleType[crow.dbMode].label : '' }}
                                                </div>
                                            </template>
                                            <template v-else>
                                                {{ crow.dbMode !== null ? moduleType[crow.dbMode].label : '' }}
                                            </template>
                                        </template>
                                    </td>
                                </tr>
                                <tr v-if="jbType !== 1">
                                    <td class="el-table__cell tdlbl tdw17 poper" colspan="1">
                                        <span class="required" style="color: red">*</span>
                                        <span style="display: inline-block">
                                            <el-tooltip placement="top" :title="$tx('dcdb.matter.jbModeContent', '交办模式说明')">
                                                <div slot="content">
                                                    <div v-text-lbl="'twoMode'">交办有自动交办和手动交办两种模式：</div>
                                                    <div class="custom-popover-p">
                                                        <span style="font-size: 40px">·</span>
                                                        <span v-text-lbl="'mode1'">自动交办:当前时间到自动交办时间后，系统自动交办。</span>
                                                    </div>
                                                    <div class="custom-popover-p">
                                                        <span style="font-size: 40px">·</span>
                                                        <span v-text-lbl="'mode2'">手动交办:用户自己在列表手动点击“交办”按钮进行交办。</span>
                                                    </div>
                                                    <div slot="reference" class="name-wrapper"></div>
                                                </div>
                                                <i class="el-icon-question">
                                                    <span v-text-lbl="'jbType'" style="color: #333; font-weight: bold">交办方式</span>
                                                </i>
                                            </el-tooltip>
                                        </span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw83" colspan="5">
                                        <template v-if="canEdit">
                                            <span v-if="vo.status === 0 || vo.taskStatus === 9" style="display: inline-block">
                                                <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="交办方式" rules="required">
                                                    <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                                        <el-radio-group v-if="jbType" v-model="jbType">
                                                            <el-radio v-text-lbl="'sdjb'" :label="2">手动交办</el-radio>
                                                            <el-radio v-text-lbl="'zdjb'" :label="1">自动交办</el-radio>
                                                        </el-radio-group>
                                                    </el-tooltip>
                                                </ValidationProvider>
                                            </span>
                                            <span v-else>{{ jbType == 1 ? '自动交办' : '手动交办' }}</span>
                                        </template>
                                        <template v-else>
                                            <span>{{ jbType == 1 ? '自动交办' : '手动交办' }}</span>
                                        </template>
                                    </td>
                                </tr>
                                <tr v-if="jbType === 1">
                                    <td class="el-table__cell tdlbl tdw17 poper" colspan="1">
                                        <span class="required" style="color: red">*</span>
                                        <span style="display: inline-block">
                                            <el-tooltip placement="top" :title="$tx('dcdb.matter.jbModeContent', '交办模式说明')">
                                                <div slot="content">
                                                    <div v-text-lbl="'twoMode'">交办有自动交办和手动交办两种模式：</div>
                                                    <div class="custom-popover-p">
                                                        <span style="font-size: 40px">·</span>
                                                        <span v-text-lbl="'mode1'">自动交办:当前时间到自动交办时间后，系统自动交办。</span>
                                                    </div>
                                                    <div class="custom-popover-p">
                                                        <span style="font-size: 40px">·</span>
                                                        <span v-text-lbl="'mode2'">手动交办:用户自己在列表手动点击“交办”按钮进行交办。</span>
                                                    </div>
                                                    <div slot="reference" class="name-wrapper"></div>
                                                </div>
                                                <i class="el-icon-question">
                                                    <span v-text-lbl="'jbType'" style="color: #333; font-weight: bold">交办方式</span>
                                                </i>
                                            </el-tooltip>
                                        </span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw33" colspan="2">
                                        <template v-if="canEdit">
                                            <span v-if="vo.status === 0 || vo.taskStatus === 1 || vo.taskStatus === 9" style="display: inline-block">
                                                <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="交办方式" rules="required">
                                                    <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                                        <el-radio-group v-if="jbType" v-model="jbType">
                                                            <el-radio v-text-lbl="'sdjb'" :label="2">手动交办</el-radio>
                                                            <el-radio v-text-lbl="'zdjb'" :label="1">自动交办</el-radio>
                                                        </el-radio-group>
                                                    </el-tooltip>
                                                </ValidationProvider>
                                            </span>
                                            <span v-else>{{ jbType == 1 ? '自动交办' : '手动交办' }}</span>
                                        </template>
                                        <template v-else>
                                            {{ jbType == 1 ? '自动交办' : '手动交办' }}
                                        </template>
                                    </td>
                                    <td class="el-table__cell tdlbl tdw17" colspan="1">
                                        <span class="required" style="color: red">*</span>
                                        <span v-text-lbl="'jbTime'">自动交办时间</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw83" colspan="2">
                                        <template v-if="canEdit">
                                            <span v-if="vo.status === 0 || vo.taskStatus === 1 || vo.taskStatus === 9" style="display: inline-block">
                                                <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="自动交办时间" rules="required">
                                                    <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                                        <el-date-picker v-model="crow.jbTime" :picker-options="pickerOptions" type="datetime" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm:ss" :placeholder="$tx('dcdb.matter.selectJbTime', '选择自动交办时间')"></el-date-picker>
                                                    </el-tooltip>
                                                </ValidationProvider>
                                            </span>
                                            <span v-else>
                                                {{ formattedReportLastTime(crow.jbTime) }}
                                            </span>
                                        </template>
                                        <template v-else>
                                            {{ formattedReportLastTime(crow.jbTime) }}
                                        </template>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="el-table__cell tdlbl tdw17" colspan="1">
                                        <span class="required" style="color: red">*</span>
                                        <span v-field-lbl="'qsLimit'">签收时限</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw83" colspan="5">
                                        <template v-if="canEdit">
                                            <span v-text-lbl="'tip.qsTip1'">责任部门收到任务的</span>
                                            <ValidationProvider v-if="vo.status === 0 || vo.taskStatus === 9" ref="ValidationProvider" v-slot="{ errors }" name="签收时限" rules="required">
                                                <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                                    <el-input-number v-model="crow.recSignLastTime" size="small" class="w120" :min="1" placeholder="" />
                                                </el-tooltip>
                                            </ValidationProvider>
                                            <span v-else>
                                                {{ crow.recSignLastTime }}
                                            </span>
                                            <span v-text-lbl="'tip.qsTip2'">
                                                天内为签收时限;
                                                <span v-if="(warningBeforeRecSign || warningBeforeRecSign === 0) && crow.matterId" class="yjTips">将在签收时限前{{ warningBeforeRecSign }}天进行预警。</span>
                                            </span>
                                        </template>
                                        <template v-else>
                                            责任部门收到任务的{{ crow.recSignLastTime }}天内为签收时限;
                                            <span v-if="(warningBeforeRecSign || warningBeforeRecSign === 0) && crow.matterId" class="yjTips">将在签收时限前{{ warningBeforeRecSign }}天进行预警。</span>
                                        </template>
                                    </td>
                                </tr>
                                <tr v-if="crow.dbMode !== 4 && crow.dbMode !== 3">
                                    <td class="el-table__cell tdlbl tdw17" colspan="1">
                                        <span class="required" style="color: red">*</span>
                                        <span v-field-lbl="'hbTime'">任务反馈提醒</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw83" colspan="5">
                                        <!-- 周督查 -->
                                        <template v-if="crow.dbMode === 0">
                                            <span v-text-lbl="'tip.hbTip3'">每周</span>
                                            <template v-if="canEdit">
                                                <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="汇报时间" rules="required">
                                                    <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                                        <!-- <el-input-number v-model="crow.createReport" size="small" class="w120" :min="1" placeholder="" /> -->
                                                        <el-select v-model="crow.createReport" size="small" class="w120" placeholder="请选择">
                                                            <el-option v-for="item in weekList" :key="item.value" :label="item.label" :value="item.value" />
                                                        </el-select>
                                                    </el-tooltip>
                                                </ValidationProvider>
                                                <span v-text-lbl="'tip.hbTip4'">
                                                    <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="定时时分交办时间" rules="required">
                                                        <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                                            <el-time-picker v-model="crow.createReportTime" style="width: 120px" format="HH:mm" value-format="HH:mm" placeholder="选择时分"></el-time-picker>
                                                        </el-tooltip>
                                                    </ValidationProvider>
                                                    生成待办提醒；
                                                </span>
                                            </template>
                                            <template v-else>{{ weekListFormat(crow.createReport) }} {{ crow.createReportTime }}生成待办提醒；</template>
                                        </template>
                                        <!-- 月督查 -->
                                        <template v-if="crow.dbMode === 1">
                                            <span v-text-lbl="'tip.hbMonthTip3'">每月</span>
                                            <template v-if="canEdit">
                                                <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="汇报时间" rules="required">
                                                    <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                                        <!-- <el-input-number v-model="crow.createReport" size="small" class="w120" :min="1" placeholder="" /> -->
                                                        <el-select v-model="crow.createReport" size="small" class="w120" placeholder="请选择">
                                                            <el-option v-for="item in numList" :key="item.value" :label="item.label" :value="item.value" />
                                                        </el-select>
                                                    </el-tooltip>
                                                </ValidationProvider>
                                                <span v-text-lbl="'tip.hbMonthTip4'">
                                                    <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="定时时分交办时间" rules="required">
                                                        <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                                            <el-time-picker v-model="crow.createReportTime" style="width: 120px" format="HH:mm" value-format="HH:mm" placeholder="选择时分"></el-time-picker>
                                                        </el-tooltip>
                                                    </ValidationProvider>
                                                    生成待办提醒；
                                                </span>
                                            </template>
                                            <template v-else>每月{{ crow.createReport }}日 {{ crow.createReportTime }}生成待办提醒；</template>
                                        </template>
                                        <!-- 季督查 -->
                                        <template v-if="crow.dbMode === 2">
                                            <span v-text-lbl="'tip.hbSeasonTip3'">每季末前</span>
                                            <template v-if="canEdit">
                                                <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="汇报时间" rules="required">
                                                    <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                                        <el-input-number v-model="crow.createReport" size="small" class="w120" :min="1" placeholder="" />
                                                    </el-tooltip>
                                                </ValidationProvider>
                                                <span v-text-lbl="'tip.hbSeasonTip4'">
                                                    <!-- 天 -->
                                                    <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="定时时分交办时间" rules="required">
                                                        <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                                            <el-time-picker v-model="crow.createReportTime" style="width: 120px" format="HH:mm" value-format="HH:mm" placeholder="选择时分"></el-time-picker>
                                                        </el-tooltip>
                                                    </ValidationProvider>
                                                    生成待办提醒；
                                                </span>
                                            </template>
                                            <template v-else>每季末前{{ crow.createReport }}天 {{ crow.createReportTime }}生成待办提醒；</template>
                                        </template>
                                    </td>
                                </tr>
                                <tr v-if="crow.dbMode === 3 && crow.atOnceCreateReport != '否'">
                                    <td class="el-table__cell tdlbl tdw17" colspan="1">
                                        <span class="required" style="color: red">*</span>
                                        <span style="display: inline-block">
                                            <el-tooltip placement="top" :title="$tx('dcdb.matter.rwfktxsm', '任务反馈提醒说明')">
                                                <div slot="content">
                                                    <div v-text-lbl="'twoMode'">由主办部门或督查科室签收工作后</div>
                                                    <div class="custom-popover-p">
                                                        <span style="font-size: 40px">·</span>
                                                        <span v-text-lbl="'mode1'">（1）可选择"立即生成"反馈单到对应任务反馈人待办；</span>
                                                    </div>
                                                    <div class="custom-popover-p">
                                                        <span style="font-size: 40px">·</span>
                                                        <span v-text-lbl="'mode2'">（2）或选择自定义任务反馈时间；</span>
                                                    </div>
                                                    <div class="custom-popover-p">
                                                        <span style="font-size: 40px">·</span>
                                                        <span v-text-lbl="'mode2'">（3）反馈截止时间为任务的完成时限。</span>
                                                    </div>
                                                    <div slot="reference" class="name-wrapper"></div>
                                                </div>
                                                <i class="el-icon-question">
                                                    <span v-text-lbl="'jbType'" style="color: #333; font-weight: bold">任务反馈提醒</span>
                                                </i>
                                            </el-tooltip>
                                        </span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw83" colspan="5">
                                        <template v-if="canEdit">
                                            <span v-if="vo.status === 0 || vo.taskStatus === 1 || vo.taskStatus === 9" style="display: inline-block">
                                                <template v-if="crow.dbMode === 3">
                                                    <el-radio-group v-model="crow.atOnceCreateReport">
                                                        <el-radio :label="'是'">立即生成待办</el-radio>
                                                        <el-radio :label="'否'">自定义时间</el-radio>
                                                    </el-radio-group>
                                                </template>
                                            </span>
                                            <span v-else>
                                                {{ crow.atOnceCreateReport === '是' ? '立即生成待办' : '自定义时间' }}
                                            </span>
                                        </template>
                                        <template v-else>
                                            <span>{{ crow.atOnceCreateReport === '是' ? '立即生成待办' : '自定义时间' }}</span>
                                        </template>
                                    </td>
                                </tr>
                                <tr v-if="crow.dbMode === 3 && crow.atOnceCreateReport == '否'">
                                    <td class="el-table__cell tdlbl tdw17" colspan="1">
                                        <span class="required" style="color: red">*</span>
                                        <span v-field-lbl="'hbTime'">任务反馈提醒</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw83" colspan="2">
                                        <!-- 一次督查 -->
                                        <template v-if="canEdit">
                                            <span v-if="vo.status === 0 || vo.taskStatus === 1 || vo.taskStatus === 9" style="display: inline-block">
                                                <template v-if="crow.dbMode === 3">
                                                    <el-radio-group v-model="crow.atOnceCreateReport">
                                                        <el-radio :label="'是'">立即生成待办</el-radio>
                                                        <el-radio :label="'否'">自定义时间</el-radio>
                                                    </el-radio-group>
                                                </template>
                                            </span>
                                            <span v-else>
                                                {{ crow.atOnceCreateReport === '是' ? '立即生成待办' : '自定义时间' }}
                                            </span>
                                        </template>
                                        <template v-else>
                                            <span>{{ crow.atOnceCreateReport === '是' ? '立即生成待办' : '自定义时间' }}</span>
                                        </template>
                                    </td>
                                    <td class="el-table__cell tdlbl tdw17" colspan="1">
                                        <span class="required" style="color: red">*</span>
                                        <span v-field-lbl="'hbTime'">自定义时间</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw83" colspan="2">
                                        <span v-text-lbl="'tip.hbSeasonTip1'">在签收后</span>
                                        <template v-if="canEdit">
                                            <span v-if="vo.status === 0 || vo.taskStatus === 1 || vo.taskStatus === 9" style="display: inline-block">
                                                <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="汇报时间" rules="required">
                                                    <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                                        <el-input-number v-model="crow.createReport" size="small" class="w120" :min="1" placeholder="" />
                                                    </el-tooltip>
                                                </ValidationProvider>
                                            </span>
                                            <span v-else>
                                                {{ crow.createReport }}
                                            </span>
                                            <span v-text-lbl="'tip.hbSeasonTip2'">天内生成反馈单；</span>
                                        </template>
                                        <template v-else>
                                            <span>{{ crow.createReport }}天内生成反馈单；</span>
                                        </template>
                                    </td>
                                </tr>
                                <tr v-if="crow.dbMode === 0 || crow.dbMode === 1 || crow.dbMode === 2">
                                    <td class="el-table__cell tdlbl tdw17" colspan="1">
                                        <span class="required" style="color: red">*</span>
                                        <span>签收后生成反馈单</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw83" colspan="5">
                                        <template v-if="canEdit">
                                            <span v-if="vo.status === 0 || vo.taskStatus === 1 || vo.taskStatus === 9" style="display: inline-block">
                                                <el-radio-group v-model="crow.atOnceCreateReport">
                                                    <el-radio :label="'是'">立即生成</el-radio>
                                                    <el-radio :label="'否'">按任务反馈提醒生成</el-radio>
                                                </el-radio-group>
                                            </span>
                                            <span v-else>
                                                {{ crow.atOnceCreateReport === '是' ? '立即生成' : '按任务反馈提醒生成' }}
                                            </span>
                                            <span style="color: red">提示：“立即生成”为当前周期反馈单，反馈截止时间为周期最后一天。</span>
                                        </template>
                                        <template v-else>
                                            <span>{{ crow.atOnceCreateReport === '是' ? '立即生成' : '按任务反馈提醒生成' }}</span>
                                            <span style="color: red">提示：“立即生成”为当前周期反馈单，反馈截止时间为周期最后一天。</span>
                                        </template>
                                    </td>
                                </tr>
                                <tr v-if="crow.dbMode !== 3">
                                    <td class="el-table__cell tdlbl tdw17" colspan="1">
                                        <span class="required" style="color: red">*</span>
                                        <span v-field-lbl="'hbTime'">反馈截止时间</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw83" colspan="5">
                                        <!-- 周督办 -->
                                        <template v-if="crow.dbMode === 0">
                                            <span v-text-lbl="'tip.hbTip3'">每周收到待办</span>
                                            <template v-if="canEdit">
                                                <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="汇报时间" rules="required">
                                                    <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                                        <el-input-number v-model="crow.reportLastTime" size="small" class="w120" :min="1" placeholder="" />
                                                    </el-tooltip>
                                                </ValidationProvider>
                                            </template>
                                            <template v-else>
                                                <span style="color: red">{{ crow.reportLastTime }}</span>
                                            </template>
                                            <span v-text-lbl="'tip.hbTip4'">
                                                天内进行工作反馈；
                                                <span v-show="(warningBeforeReport || warningBeforeReport === 0) && crow.matterId" class="yjTips">将在反馈截止时间前{{ warningBeforeReport }}天进行预警。</span>
                                            </span>
                                        </template>
                                        <!-- 月督办 -->
                                        <template v-if="crow.dbMode === 1">
                                            <span v-text-lbl="'tip.hbMonthTip3'">每月收到待办</span>
                                            <template v-if="canEdit">
                                                <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="汇报时间" rules="required">
                                                    <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                                        <el-input-number v-model="crow.reportLastTime" size="small" class="w120" :min="1" placeholder="" />
                                                    </el-tooltip>
                                                </ValidationProvider>
                                            </template>
                                            <template v-else>
                                                <span style="color: red">{{ crow.reportLastTime }}</span>
                                            </template>
                                            <span v-text-lbl="'tip.hbMonthTip4'">
                                                天内进行工作反馈；
                                                <span v-show="(warningBeforeReport || warningBeforeReport === 0) && crow.matterId" class="yjTips">将在反馈截止时间前{{ warningBeforeReport }}天进行预警。</span>
                                            </span>
                                        </template>
                                        <!-- 季督办 -->
                                        <template v-if="crow.dbMode === 2">
                                            <span v-text-lbl="'tip.hbSeasonTip3'">每季收到待办</span>
                                            <template v-if="canEdit">
                                                <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="汇报时间" rules="required">
                                                    <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                                        <el-input-number v-model="crow.reportLastTime" size="small" class="w120" :min="1" placeholder="" />
                                                    </el-tooltip>
                                                </ValidationProvider>
                                            </template>
                                            <template v-else>
                                                <span style="color: red">{{ crow.reportLastTime }}</span>
                                            </template>
                                            <span v-text-lbl="'tip.hbSeasonTip4'">
                                                天内进行工作反馈；
                                                <span v-show="(warningBeforeReport || warningBeforeReport === 0) && crow.matterId" class="yjTips">将在反馈截止时间前{{ warningBeforeReport }}天进行预警。</span>
                                            </span>
                                        </template>
                                        <!-- 一次督办 -->
                                        <template v-if="crow.dbMode === 3">
                                            <span v-text-lbl="'tip.hbOnceTip1'" style="padding-right: 5px">主办部门</span>
                                            <template v-if="canEdit">
                                                <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="汇报时间" rules="required">
                                                    <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                                        <el-date-picker v-model="crow.createReport" style="width: 200px" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择生成待办时间"></el-date-picker>
                                                    </el-tooltip>
                                                </ValidationProvider>
                                                <span v-text-lbl="'tip.hbOnceTip2'" style="padding-left: 5px">生成待办；</span>
                                                <span v-text-lbl="'tip.hbOnceTip3'">在收到待办</span>
                                                <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="汇报时间" rules="required">
                                                    <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                                        <el-input-number v-model="crow.reportLastTime" size="small" class="w120" :min="1" placeholder="" />
                                                    </el-tooltip>
                                                </ValidationProvider>
                                            </template>
                                            <template v-else>
                                                <span style="color: red">{{ crow.createReport }}生成待办；在收到待办{{ crow.reportLastTime }}</span>
                                            </template>
                                            <span v-text-lbl="'tip.hbOnceTip4'">
                                                天内进行工作反馈；
                                                <span v-show="(warningBeforeReport || warningBeforeReport === 0) && crow.matterId" class="yjTips">将在反馈截止时间前{{ warningBeforeReport }}天进行预警。</span>
                                            </span>
                                        </template>
                                        <!-- 自定义 -->
                                        <template v-if="crow.dbMode === 4">
                                            <span v-text-lbl="'tip.hbZdyTip1'">收到待办</span>
                                            <template v-if="canEdit">
                                                <ValidationProvider ref="ValidationProvider" v-slot="{ errors }" name="汇报时间" rules="required">
                                                    <el-tooltip :disabled="errors[0] === undefined" :content="errors[0]" :class="{ 'invalid-field': errors[0] !== undefined }" popper-class="error-popper-class" placement="right-start" effect="dark">
                                                        <el-input-number v-model="crow.reportLastTime" size="small" class="w120" :min="1" placeholder="" />
                                                    </el-tooltip>
                                                </ValidationProvider>
                                            </template>
                                            <template v-else>
                                                <span style="color: red">{{ crow.reportLastTime }}</span>
                                            </template>
                                            <span v-text-lbl="'tip.hbZdyTip2'">
                                                天内进行工作反馈；
                                                <!-- <span v-if="(warningBeforeReport || warningBeforeReport === 0) && crow.matterId" class="yjTips">将在反馈截止时间前{{ warningBeforeReport }}天进行预警。</span> -->
                                            </span>
                                        </template>
                                    </td>
                                </tr>

                                <tr v-if="crow.dbMode === 3">
                                    <td class="el-table__cell tdlbl tdw17" colspan="1">
                                        <!-- <span class="required" style="color: red">*</span> -->
                                        <span>反馈截止时间</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw83" colspan="5">
                                        <!-- 一次督查 -->
                                        <span style="margin: 0 5px">
                                            {{ formattedReportLastTime(vo.overDate) }}
                                        </span>
                                        <span v-show="(warningBeforeReport || warningBeforeReport === 0) && crow.matterId" class="yjTips">将在反馈截止时间前{{ warningBeforeReport }}天进行预警。</span>
                                    </td>
                                </tr>
                                <tr>
                                    <td class="el-table__cell tdlbl tdw17" colspan="1">
                                        <!-- <span class="required" style="color: red">*</span> -->
                                        <span>完成时限</span>
                                    </td>
                                    <td class="el-table__cell tdcont tdw83" colspan="5">
                                        <span style="margin: 0 5px">
                                            {{ formattedReportLastTime(vo.overDate) }}
                                        </span>
                                        <span v-if="(warningBeforeComplete || warningBeforeComplete === 0) && crow.matterId" class="yjTips">将在完成时限前{{ warningBeforeComplete }}天进行预警。</span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </el-form>

            <div v-if="crow.dbMode === 4" style="margin-top: 20px" class="dialogFk">
                <div style="border-top: 1px solid #dee2e6">
                    <div class="rwfk title" style="border-left: 1px solid #dee2e6; border-right: 1px solid #dee2e6">
                        <!-- 任务反馈，单任务 -->
                        <div style="font-size: var(--portalFontSize14); color: #000; font-weight: 600">
                            任务反馈提醒
                            <span style="color: red">（提示：将在任务反馈提醒时间生成反馈待办单）</span>
                        </div>
                        <div v-if="canEdit" class="rwfk-btn" style="display: flex">
                            <div>
                                <el-button size="mini" style="border: 0px" @click="addrwfk">添加</el-button>
                            </div>
                        </div>
                    </div>
                    <div v-if="crow.dbMode === 4" class="fks" style="border-left: 1px solid #dee2e6; border-bottom: 1px solid #dee2e6">
                        <el-table ref="multipleTable" class="lyy-table el-table--border" :data="crow.passenger.customFeedbacks" tooltip-effect="dark" style="width: 100%; border-left: none" :row-style="{ cursor: 'pointer' }" :header-cell-style="{ background: '#fff' }" @selection-change="handleSelectionChangeFk">
                            <el-table-column align="center" type="selection" width="45" />
                            <el-table-column type="index" width="50" label="序号" align="center"></el-table-column>
                            <el-table-column align="left" prop="feedbackTime" label="任务反馈提醒" show-overflow-tooltip>
                                <template slot-scope="scope">
                                    <div>
                                        <template v-if="canEdit">
                                            <el-date-picker v-model="scope.row.feedbackTime" :default-time="'09:00:00'" style="width: 100%" :step-num="5" :clearable="true" :editable="false" name="feedbackTime" type="datetime" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" :placeholder="'请选择年月日时分'" :picker-options="pickerOptions" @change="updateFeedbackLimitTime(scope.row)" />
                                        </template>
                                        <template v-else>
                                            <span>{{ scope.row.feedbackTime }}</span>
                                        </template>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column align="left" prop="feedbackTime" label="反馈截止时间" show-overflow-tooltip>
                                <template slot="header">
                                    反馈截止时间
                                    <span v-show="(warningBeforeReport || warningBeforeReport === 0) && crow.matterId" class="yjTips">（将在反馈截止时间前{{ warningBeforeReport }}天进行预警。）</span>
                                </template>
                                <template slot-scope="scope">
                                    <div>
                                        <template v-if="canEdit">
                                            <el-date-picker v-model="scope.row.feedbackLimitTime" :default-time="'09:00:00'" style="width: 100%" :step-num="5" :clearable="true" :editable="false" name="feedbackLimitTime" type="datetime" format="yyyy-MM-dd HH:mm" value-format="yyyy-MM-dd HH:mm" :placeholder="'请选择年月日时分'" :picker-options="pickerOptions" />
                                        </template>
                                        <template v-else>
                                            <span>{{ scope.row.feedbackLimitTime }}</span>
                                        </template>
                                    </div>
                                    <!-- <span v-else>{{ scope.row.feedbackLimitTime.substr(0, 16) }}</span> -->
                                </template>
                            </el-table-column>
                            <el-table-column v-if="!vo.isPl & false" align="left" prop="qtDept" :label="$tx('dcdb.sumReportInfo.qtDept', '主办部门')" width="250" show-overflow-tooltip />
                            <el-table-column v-if="!vo.isPl & false" align="left" prop="phDept" :label="$tx('dcdb.sumReportInfo.hpDept', '配合部门')" width="250" show-overflow-tooltip />
                            <el-table-column v-if="canEdit" align="center" label="操作" width="70" show-overflow-tooltip>
                                <template slot-scope="scope">
                                    <el-link @click="remove(scope.row)">删除</el-link>
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                </div>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button v-pageBtn-lbl="'cancel'" :icon="'el-icon-close'" @click="close">取 消</el-button>
                <template v-if="canEdit">
                    <el-button v-pageBtn-lbl="'cancel'" type="primary" :icon="'el-icon-check'" @click="handleSave">保 存</el-button>
                    <el-button v-if="jbType == 2 && !vo.isPl && vo.status === 0" v-pageBtn-lbl="'cancel'" type="primary" :icon="'el-icon-check'" @click="handleSave('2')">立即交办</el-button>
                    <el-button v-pageBtn-lbl="'cancel'" type="primary" :icon="'el-icon-check'" @click="handleSave('3')">下一个</el-button>
                </template>
            </span>
        </el-dialog>
    </div>
</template>

<script>
const moment = require('moment')
import FileList from './FileList'
export default {
    components: {
        FileList
    },
    props: {},
    data() {
        return {
            loginUser: this.$store.getters.loginUser,
            i18npkg: 'dcdb',
            moduleCode: 'matter',
            crow: {},
            dialogFormVisible: false,
            form: {},
            vo: {},
            canEdit: 1, // 1可编辑 0不可编辑
            isLoading: false,
            isNew: false,
            dbModeOne: null,
            dbModeLast: null,
            visibleTsxx: false, // 提示信息弹窗
            type: [
                {
                    value: 1,
                    label: this.$tx('dcdb.matter.before', '前')
                },
                {
                    value: 2,
                    label: this.$tx('dcdb.matter.after', '后')
                }
            ],
            weekList: [
                {
                    value: 1,
                    label: this.$tx('common.Monday', '周一')
                },
                {
                    value: 2,
                    label: this.$tx('common.Tuesday', '周二')
                },
                {
                    value: 3,
                    label: this.$tx('common.Wednesday', '周三')
                },
                {
                    value: 4,
                    label: this.$tx('common.Thursday', '周四')
                },
                {
                    value: 5,
                    label: this.$tx('common.Friday', '周五')
                },
                {
                    value: 6,
                    label: this.$tx('common.Saturday', '周六')
                },
                {
                    value: 7,
                    label: this.$tx('common.Sunday', '周日')
                }
            ],
            moduleType: [
                {
                    value: 0,
                    label: '周督查'
                },
                {
                    value: 1,
                    label: '月度督查'
                },
                {
                    value: 2,
                    label: '季度督查'
                },
                {
                    value: 3,
                    label: '一次督查'
                },
                {
                    value: 4,
                    label: '自定义'
                }
            ],
            jbType: null,
            taskObj: {},
            numList: [
                { value: 1, label: '1日' },
                { value: 2, label: '2日' },
                { value: 3, label: '3日' },
                { value: 4, label: '4日' },
                { value: 5, label: '5日' },
                { value: 6, label: '6日' },
                { value: 7, label: '7日' },
                { value: 8, label: '8日' },
                { value: 9, label: '9日' },
                { value: 10, label: '10日' },
                { value: 11, label: '11日' },
                { value: 12, label: '12日' },
                { value: 13, label: '13日' },
                { value: 14, label: '14日' },
                { value: 15, label: '15日' },
                { value: 16, label: '16日' },
                { value: 17, label: '17日' },
                { value: 18, label: '18日' },
                { value: 19, label: '19日' },
                { value: 20, label: '20日' },
                { value: 21, label: '21日' },
                { value: 22, label: '22日' },
                { value: 23, label: '23日' },
                { value: 24, label: '24日' },
                { value: 25, label: '25日' },
                { value: 26, label: '26日' },
                { value: 27, label: '27日' },
                { value: 28, label: '28日' },
                { value: 29, label: '29日' },
                { value: 30, label: '30日' },
                { value: 31, label: '31日' }
            ],
            dbTypeOptions: [],
            warningList: [],
            warningBeforeRecSign: null, // 签收
            warningBeforeComplete: null, // 任务到期
            selectRow: {},
            isHttp: false,
            warningBeforeReport: null // 汇报到期
        }
    },
    computed: {},
    watch: {
        dialogFormVisible(val) {
            if (val && this.vo.isJb) {
                setTimeout(() => {
                    this.$message.warning(this.$tx('dcdb.messages.setRules', '请先设置监管规则！'))
                }, 500)
            }
            if (this.crow.dbMode === 0 || this.crow.dbMode === 2 || this.crow.dbMode === 1) {
                this.crow.createReport = this.crow.createReport ? Number(this.crow.createReport) : 1
            }
            this.crow.reportLastTime = this.crow.reportLastTime ? Number(this.crow.reportLastTime) : 1
            // this.crow.jbType = this.crow.jbType ? Number(this.crow.jbType) : 2
            if (!this.crow.jbType) {
                // this.crow.jbType = 1
                this.jbType = 1
            } else {
                this.jbType = this.crow.jbType
            }
            if (!this.crow.atOnceCreateReport) {
                this.crow.atOnceCreateReport = '是'
            }
            if (!this.crow.dbMode) {
                this.crow.dbMode = this.vo.dbMode
            }
            if (!this.crow.jbTime) {
                this.crow.jbTime = new Date(new Date().setHours(8, 0, 0, 0))
            }
            if (!this.crow.enableWarn) {
                this.crow.enableWarn = 0
            }

            // this.crow.redCompleteType = this.crow.redCompleteType ? Number(this.crow.redCompleteType) : 1
            // this.crow.redRecSignType = this.crow.redRecSignType ? Number(this.crow.redRecSignType) : 1
            // this.crow.redReportType = this.crow.redReportType ? Number(this.crow.redReportType) : 1
            // this.crow.yellowCompleteType = this.crow.yellowCompleteType ? Number(this.crow.yellowCompleteType) : 2
            // this.crow.yellowRecSignType = this.crow.yellowRecSignType ? Number(this.crow.yellowRecSignType) : 2
            // this.crow.yellowReportType = this.crow.yellowReportType ? Number(this.crow.yellowReportType) : 2
            if (this.crow.warningBeforeRecSign || this.crow.warningBeforeRecSign === 0) {
                this.warningBeforeRecSign = this.crow.warningBeforeRecSign
            }
            if (this.crow.warningBeforeComplete || this.crow.warningBeforeComplete === 0) {
                this.warningBeforeComplete = this.crow.warningBeforeComplete
            }
            if (this.crow.warningBeforeReport || this.crow.warningBeforeReport === 0) {
                this.warningBeforeReport = this.crow.warningBeforeReport
            }

            if (this.warningList.length > 0) {
                this.warningList.forEach((item, index) => {
                    if (item.dbType === this.vo.dbType) {
                        // 签收
                        if (!this.warningBeforeRecSign && this.warningBeforeRecSign !== 0 && item.warningType === 3) {
                            //this.warningBeforeRecSign = item.preWarningDay
                            this.$set(this, 'warningBeforeRecSign', item.preWarningDay)
                        }
                        // 任务到期
                        if (!this.warningBeforeComplete && this.warningBeforeComplete !== 0 && item.warningType === 2) {
                            // this.warningBeforeComplete = item.preWarningDay
                            this.$set(this, 'warningBeforeComplete', item.preWarningDay)
                        }
                        // 汇报到期
                        if (!this.warningBeforeReport && this.warningBeforeReport !== 0 && item.warningType === 1) {
                            // this.warningBeforeReport = item.preWarningDay
                            this.$set(this, 'warningBeforeReport', item.preWarningDay)
                        }
                    }
                })
            }

            console.log(this.warningBeforeRecSign, '将在签收时限前' + this.warningBeforeRecSign + '天进行预警')
            console.log(this.warningBeforeComplete, '将在完成时限前' + this.warningBeforeComplete + '天进行预警')
            console.log(this.warningBeforeReport, '将在反馈截止时间前' + this.warningBeforeReport + '天进行预警')
            this.getTaskObj()
        },
        // 深度监听crow对象的变化
        crow: {
            handler(newValue, oldValue) {
                // 当crow对象或其嵌套属性发生变化时，这个函数会被调用
                console.log('crow对象发生了变化', newValue, oldValue, this)
                if (this.crow.enableWarn === 0) {
                    this.crow.redCompleteType = 1
                    this.crow.redRecSignType = 1
                    this.crow.redReportType = 1
                    this.crow.yellowCompleteType = 1
                    this.crow.yellowRecSignType = 1
                    this.crow.yellowReportType = 1
                }
            },
            deep: true // 启用深度监听
        },
        'crow.reportLastTime'(newValue, oldValue) {
            this.previousReportLastTime = newValue
            if (newValue !== oldValue && this.crow.passenger && this.crow.passenger.customFeedbacks && this.crow.passenger.customFeedbacks.length > 0) {
                this.crow.passenger.customFeedbacks.forEach((it, i) => {
                    if (it.feedbackTime) {
                        const feedbackTimeMoment = moment(it.feedbackTime, 'YYYY-MM-DD HH:mm:ss') // 将字符串转换为moment对象
                        this.$set(it, 'feedbackLimitTime', feedbackTimeMoment.add(newValue, 'days').format('YYYY-MM-DD HH:mm:ss'))
                    }
                })
            }
        }
    },
    created() {
        this.$bus.on('openBusiformJb', this.openBusiformJb)
        console.log('$i18n.locale====', this.$i18n.locale)
        // if (!this.crow.redCompleteType) {
        //     this.crow.redCompleteType = 1
        // }
        // if (!this.crow.redRecSignType) {
        //     this.crow.redRecSignType = 1
        // }
        // if (!this.crow.redReportType) {
        //     this.crow.redReportType = 1
        // }
        // if (!this.crow.yellowCompleteType) {
        //     this.crow.yellowCompleteType = 1
        // }
        // if (!this.crow.yellowRecSignType) {
        //     this.crow.yellowRecSignType = 1
        // }
        // if (!this.crow.yellowReportType) {
        //     this.crow.yellowReportType = 1
        // }
        // if (!this.crow.atOnceCreateReport) {
        //     this.crow.atOnceCreateReport = '是'
        // }
        // if (!this.crow.dbMode) {
        //     this.crow.dbMode = this.vo.dbMode
        // }
        // if (!this.crow.enableWarn) {
        //     this.crow.enableWarn = 0
        // }
        // if (!this.crow.jbTime) {
        //     this.crow.jbTime = new Date(new Date().setHours(8, 0, 0, 0))
        // }

        this.getWarningSettingList()
    },
    beforeDestroy() {},
    mounted() {},
    methods: {
        openBusiformJb(row, type) {
            // 转任务交办 row: 会议或议题数据  type: 1: 会议纪要  2：会议议题
            this.selectRow = row
            var fileList = []
            this.$http({
                method: 'post',
                url: '/dcdb/matter/addNew'
            }).then((res) => {
                if (res.code === 'success') {
                    this.vo = res.body.vo
                    this.dbTypeOptions = this.vo.passenger.dbTypeOptions
                    // if (!this.vo.creatorId) {
                    // var org = this.wfInstance.createOrgName.split('-')
                    this.vo.creatorId = this.loginUser.personId
                    this.vo.flCreator = this.loginUser.personName
                    this.vo.orgCode = this.loginUser.orgCode
                    this.vo.flCreateDate = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
                    this.vo.flCreateDept = this.loginUser.staffList[0].orgFullName.split('-')[1]
                    // this.vo.orgFullId = this.wfInstance.createOrgId
                    // this.vo.orgName = this.wfInstance.orgName
                    this.vo.status = 0
                    // }
                    this.vo.passenger.matterRule.jbType = '2'
                    this.vo.passenger.matterRule.passenger.customFeedbacks = []

                    fileList = JSON.parse(JSON.stringify(row.passenger.attachIds))

                    if (fileList.length > 0) {
                        fileList.forEach((item) => {
                            item.fileType = 'ATTACH'
                            item.checked = true
                        })
                    }
                    if (this.vo.meetingName) {
                        this.vo.passenger.task.title = row.subject + '【' + this.vo.meetingName + '】'
                    } else {
                        this.vo.passenger.task.title = row.subject
                    }
                    this.vo.passenger.task.content = row.passenger.meetingMinutes
                    this.vo.passenger.task.passenger.ytInfoId = row.id
                    this.vo.sourceId = this.selectRow.id

                    this.vo.passenger.attachments = fileList
                    this.vo.passenger.matterRule.enableWarn = 0
                    let selected = this.loginUser.personName
                    let selectedId = this.loginUser.personId
                    let selectedPhone = this.loginUser.personMobile
                    var orgArr = this.loginUser.staffList[0].orgFullName.split('-')
                    var orgIdArr = this.loginUser.staffList[0].orgFullId.split('-')
                    this.$set(this.vo, 'dbMater', selected)
                    this.$set(this.vo, 'dbMaterUserId', selectedId)
                    this.$set(this.vo, 'dbMaterLinkInfo', selectedPhone)
                    this.$set(this.vo, 'dbMaterDept', orgArr[orgArr.length - 1])
                    this.$set(this.vo, 'dbMaterDeptId', orgIdArr[orgIdArr.length - 1])
                    this.crow = this.vo.passenger.matterRule
                    this.getWarningSettingList()
                    this.dialogFormVisible = true
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        // 获取预警设置所有数据
        async getWarningSettingList() {
            const data = [
                { compare: '=', field: 'status', merge: false, value: 1 },
                { compare: '=', field: 'warningCard', merge: false, value: 1 }
            ]
            const res = await this.$app.querydata('dcdb/warningRule/querydata', data)
            if (res.code === 'success') {
                this.warningList = res.body.listdata
            }
        },
        updateFeedbackLimitTime(row) {
            if (row.feedbackTime) {
                const feedbackTimeMoment = moment(row.feedbackTime, 'YYYY-MM-DD HH:mm:ss')
                const newValue = this.crow.reportLastTime
                this.$set(row, 'feedbackLimitTime', feedbackTimeMoment.add(newValue, 'days').format('YYYY-MM-DD HH:mm:ss'))
            }
        },
        formattedReportLastTime(reportLastTime) {
            // 检查reportLastTime是否为有效的日期字符串
            if (reportLastTime) {
                // 使用Moment.js格式化日期
                return moment(reportLastTime).format('YYYY-MM-DD HH:mm')
            } else {
                // 如果reportLastTime不是有效的日期，你可以返回一个默认值或占位符
                // 但基于你的原始代码，这里可能需要不同的逻辑
                return '未知日期'
            }
        },
        changeValue() {
            if (!this.crow.createReport) {
                this.crow.createReport = 3
            }
            if (!this.crow.createReportTime) {
                this.crow.createReportTime = '09:00'
            }
            if (!this.crow.reportTime) {
                this.crow.reportTime = '09:00'
            }
        },
        async getTaskObj() {
            const data = [
                {
                    compare: '=',
                    field: 'parentId',
                    merge: true,
                    value: this.vo.id
                }
            ]
            const res = await this.$app.querydata('/dcdb/task/querydata', data)
            if (res.code === 'success' && res.body.listdata.length > 0) {
                this.taskObj = res.body.listdata[0]
                this.$bus.emit('refreshListData')
            } else {
                this.taskObj = {
                    id: '',
                    parentId: '',
                    qtDeptId: '',
                    qtDept: '',
                    phDeptId: '',
                    phDept: '',
                    passenger: {}
                }
            }
        },
        // 保存
        handleSave(type) {
            const _this = this
            if (this.isLoading) return
            // eslint-disable-next-line eqeqeq
            if (this.crow.dbMode != 4 && !this.crow.reportLastTime && this.crow.reportLastTime !== 0) {
                this.$alert('请填写汇报时间！', this.$tx('dcdb.optionTip'), {
                    type: 'warning'
                })
                return
            }
            if (!this.crow.jbTime && this.jbType != 2) {
                this.$alert('请填写交办时间！', this.$tx('dcdb.optionTip'), {
                    type: 'warning'
                })
                return
            }

            if (!this.crow.createReport) {
                this.crow.createReport = 1
            }
            if (!this.crow.createReportTime) {
                this.crow.createReportTime = '23:59'
            }
            if (!this.crow.reportTime) {
                this.crow.reportTime = '08:00'
            }

            this.crow.jbType = this.jbType
            this.isLoading = true
            console.log('this.crow', this.crow)
            if (this.crow.dbMode === 4) {
                if (!this.crow.passenger.customFeedbacks) this.crow.passenger.customFeedbacks = []
                this.crow.passenger.customFeedbacks = this.crow.passenger.customFeedbacks.filter((item) => item.feedbackTime || item.feedbackLimitTime)
            }
            this.vo.flSubject = this.vo.passenger.task.title
            this.vo.passenger.matterRule = this.crow
            this.vo.passenger.attachments = this.vo.passenger.attachments.filter(item => item.id && item.checked)

            this.formValidate(() => {
                this.isHttp = true
                this.canEdit = true
                this.$http({
                    method: 'post',
                    url: '/dcdb/matter/insertNewMatter',
                    data: this.vo
                }).then(res => {
                    if (res.code === 'success') {
                        _this.uploadAttact(this.vo.passenger.attachments, this.vo).then((result) => {
                            if (result.code === 'success') {
                                if (type == 2) {
                                    _this.jiaoban(res.body.vo.id)
                                } else if (type == 3) {
                                    // _this.canEdit = false
                                    _this.dialogFormVisible = false
                                    this.isHttp = false
                                    this.$bus.emit('nextData')
                                } else {
                                    this.$message.success(res.message)
                                    // _this.canEdit = false
                                    _this.dialogFormVisible = false
                                    this.isHttp = false
                                }
                                // _this.canEdit = false
                            }
                        })
                        // this.$message.success(res.message)
                        // _this.xzdbytShow = false
                    } else {
                        this.$message.error(res.message)
                        // this.canEdit = false
                        this.isHttp = false
                    }
                })
            }, null, 1)
        },
        uploadAttact(list, vo) {
            this.doing = true
            var fileList = list.filter(item => !item.id)
            var _this = this
            console.log('list, vo', list, vo)
            return new Promise((resolve, reject) => {
                if (!fileList.length) {
                    resolve({ code: 'success', message: '未发现需要上传的附件。', result: [] })
                } else {
                    const array = []
                    fileList.forEach(item => {
                        const fd = new FormData()
                        fd.append('file', item.file.raw)
                        fd.append('module', 'ytRecord')
                        fd.append('attachsSize', item.file.size)
                        fd.append('busiDataId', vo.passenger.ytRecordId)
                        fd.append('attachsType', 'ATTACH')
                        fd.append('attachsName', item.file.name)
                        fd.append('uploadBy', _this.loginUser.personName)
                        fd.append('uploadById', _this.loginUser.userId)
                        array.push(this.$http({
                            method: 'POST',
                            // url: _this.moduleInfo.updateUrl.replace('update', 'upload'),
                            url: 'hygl/ytRecord/upload',
                            data: fd
                        }))
                    })
                    Promise.all(array).then(res => {
                        if (res.length === fileList.length) {
                            resolve({ code: 'success', message: '全部附件上传完成。', result: res })
                        }
                    })
                }
            })
        },

        getFormValidate() {
            if (this.vo.dbType === null || this.vo.dbType === 'null') {
                this.$alert('督办类型是必须的。', '操作提示', { type: 'warning' })
                return false
            }
            if (this.vo.dbMode === null || this.vo.dbMode === 'null') {
                this.$alert('督办模式是必须的。', '操作提示', { type: 'warning' })
                return false
            }
            // if (this.vo.importantLevel === null || this.vo.importantLevel === 'null') {
            //     this.$alert('重要程度是必须的。', '操作提示', { type: 'warning' })
            //     return false
            // }
            // if (this.vo.urgentLevel === null || this.vo.urgentLevel === 'null') {
            //     this.$alert('紧急程度是必须的。', '操作提示', { type: 'warning' })
            //     return false
            // }
            if (!this.vo.dbMater) {
                this.$alert('督办人是必须的。', '操作提示', { type: 'warning' })
                return false
            }
            if (!this.vo.dbMaterDept) {
                this.$alert('督办部门是必须的。', '操作提示', { type: 'warning' })
                return false
            }
            if (!this.vo.passenger.task.title) {
                this.$alert('任务标题是必须的。', '操作提示', { type: 'warning' })
                return false
            }
            if (!this.vo.passenger.task.content) {
                this.$alert('任务内容是必须的。', '操作提示', { type: 'warning' })
                return false
            }
            if (!this.vo.passenger.task.qtDept) {
                this.$alert('承办部门是必须的。', '操作提示', { type: 'warning' })
                return false
            }
            if (!this.vo.passenger.task.startDate) {
                this.$alert('开始时间是必须的。', '操作提示', { type: 'warning' })
                return false
            }
            if (!this.vo.passenger.task.overDate) {
                this.$alert('完成时限是必须的。', '操作提示', { type: 'warning' })
                return false
            }
            // if (!this.vo.passenger.matterRule.reportLastTime) {
            //     this.$alert('汇报时间是必须的。', '操作提示', { type: 'warning' })
            //     return false
            // }
            if (this.vo.passenger.task.phDept) {
                let _this = this
                let key = false
                key = _this.vo.passenger.task.phDept.split('、').some(function(item) {
                    return _this.vo.passenger.task.qtDept.split('、').includes(item)
                })

                if (key) {
                    this.$alert('承办部门与会办部门不能重复', '操作提示', { type: 'warning' })
                    return false
                }
            }

            return true
        },
        jiaoban(id) {
            this.$http({
                url: '/dcdb/matter/startJb',
                method: 'post',
                params: {
                    matterId: id
                }
            }).then(res => {
                if (res.code === 'success') {
                    this.$message.success(res.message)
                    // this.canEdit = false
                    this.dialogFormVisible = false
                    this.$nextTick(() => {
                        this.$vnode.context.showBasicForm = false
                    })
                } else {
                    this.$message.error(res.message)
                    // this.canEdit = false
                }
                this.isHttp = false
            })
        },
        async updateRule(row, type, jbType) {
            let res = ''

            if (this.vo.url) {
                this.$http({
                    url: this.vo.url,
                    method: 'post',
                    data: row
                }).then((res) => {
                    if (res.code === 'success') {
                        this.dialogFormVisible = false
                        this.$message.success(res.message)
                        this.$vnode.context.watchRuleShow = false
                        this.$bus.emit('refreshListData')
                    } else {
                        this.$message({ message: res.message, type: 'warning' })
                    }
                    this.isLoading = false
                })
            } else {
                if (type === 'insert') {
                    row.matterId = this.vo.id
                    res = await this.$app.insert('/dcdb/matterRule/insert', row)
                } else {
                    res = await this.$app.update('/dcdb/matterRule/update', row)
                }
                if (res.code === 'success') {
                    if (jbType == '2') {
                        // 执行交办操作
                        this.$vnode.context.jiaoban(this.vo)
                    } else {
                        this.dialogFormVisible = false
                        this.$message.success(res.message)
                        this.$vnode.context.watchRuleShow = false
                        this.$bus.emit('refreshListData')
                        this.isLoading = false
                    }
                } else {
                    this.$message({ message: res.message, type: 'warning' })
                }
                setTimeout(() => {
                    this.isLoading = false
                }, 1000)
            }
        },
        close() {
            console.log(this.$vnode.context)
            this.dialogFormVisible = false
            this.$vnode.context.watchRuleShow = false
        },
        optionChange($event, val) {
            if (Number($event) === 2) {
                this.crow[val] = 2
            }
        },
        // 删除当前行
        remove(row) {
            this.crow.passenger.customFeedbacks = this.crow.passenger.customFeedbacks.filter((item) => item.id !== row.id)
        },
        // 新增一行任务反馈
        async addrwfk() {
            const _this = this

            try {
                var resfk = await this.$app.addNew('/dcdb/customFeedback/addNew')
                if (resfk.code === 'success') {
                    resfk.body.vo.taskId = _this.taskObj.id
                    resfk.body.vo.qtDeptId = _this.taskObj.qtDeptId
                    resfk.body.vo.qtDept = _this.taskObj.qtDept
                    resfk.body.vo.phDeptId = _this.taskObj.phDeptId
                    resfk.body.vo.phDept = _this.taskObj.phDept
                    // resfk.body.vo.feedbackTime = new Date(new Date().setHours(23, 59, 0, 0))

                    if (!_this.crow.passenger.customFeedbacks) {
                        _this.crow.passenger = { customFeedbacks: [resfk.body.vo] }
                    } else {
                        _this.crow.passenger.customFeedbacks.push(resfk.body.vo)
                    }

                    console.log(_this.crow.passenger, 'this.taskObj')
                } else {
                    this.$message({
                        message: resfk.message,
                        type: 'warning'
                    })
                }
            } catch (error) {
                // 添加一个catch块来处理任何可能的异步错误
                console.error('An error occurred:', error)
                this.$message({
                    message: '发生错误，请稍后再试。',
                    type: 'error'
                })
            }
        },
        // // 选择部门
        onSelectSuborgCompleted(selectedNodes, attr) {
            let name = []
            let ids = []
            selectedNodes.forEach(item => {
                name.push(item.name)
                ids.push(item.id)
            })
            if (attr.name === 'qtDept') {
                this.vo.passenger.task.qtDept = name.join('、')
                this.vo.passenger.task.qtDeptId = ids.join(',')
            } else {
                this.vo.passenger.task.phDept = name.join('、')
                this.vo.passenger.task.phDeptId = ids.join(',')
            }
        },
        weekListFormat(val) {
            const num = Number(val)
            const week = ['一', '二', '三', '四', '五', '六', '日']
            return week[num - 1]
        }
    }
}
</script>

<style scoped lang="scss">
.rule /deep/ .el-dialog__body {
    max-height: calc(100vh - 320px);
    overflow: auto;
}

.name-wrapper {
    cursor: pointer;
    /* 当鼠标悬停时显示手形图标，表明是可点击或可交互的 */
}

.w120 {
    width: 120px;
    margin: 0 5px;
}

.W50 {
    width: 60px;
    margin: 0 5px;
}

/deep/ .w120 input {
    padding-right: 0;
}

/deep/ .W50 input {
    padding-right: 0;
}

.yellow-box {
    display: inline-block;
    width: 20px;
    height: 20px;
    background: yellow;
    margin: 0 6px;
    position: relative;
    top: 3px;
}

.red-box {
    display: inline-block;
    width: 20px;
    height: 20px;
    background: red;
    margin: 0 6px;
    position: relative;
    top: 3px;
}

.custom-popover-p {
    display: flex;
    justify-content: start;
    align-items: center;
    height: 24px;
}

/* 标题样式（如果需要） */
.custom-popover .el-popover__title {
    color: #fff;
    /* 标题文字也设为白色 */
}

/* 如果需要调整其他样式，可以继续添加 */
.custom-popover .name-wrapper {
    display: flex;
    align-items: center;
}

.custom-popover .name-wrapper i {
    margin-right: 8px;
    /* 图标和文字之间的间距 */
}
.taskList .table-toolbar-left-slot {
    display: none !important;
}

.taskList {
    margin-top: 20px;
}

.title {
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: var(--portalFontSize13);
    padding: 0 16px;
    background-color: #f2f5fb;
}

.dialogFk /deep/ .el-table thead th {
    background: #f2f5fb !important;
}

.dialogFk .title {
    background: #fff;
}
.yjTips {
    color: red;
    font-weight: 400;
}
</style>
